// extracted by mini-css-extract-plugin
export default {"container":"hS-z","topReviewHeading":"iS-z","criticalReview":"jS-z","favorableReview":"kS-z","vsSeparator":"lS-z"};